<template>
  <svg class="menu-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14">
    <path d="M-6144,14V12h-10v2Zm0-6V6h-16V8Zm0-6V0h-16V2Z" transform="translate(6160)" fill="#2699fb"/>
  </svg>
</template>

<script>
  export default {
    name: 'MenuIcon'
  }
</script>

<style>

</style>